import React, { useState, useEffect } from "react";
import {
    SearchOutlined,
    CheckOutlined,
    CloseOutlined,
    WarningOutlined,
} from "@ant-design/icons";
import {
    Layout,
    Button,
    theme,
    ConfigProvider,
    Input,
    Row,
    Typography,
    Col,
    Card,
    Select,
    Breadcrumb,
    Form,
    DatePicker,
    Checkbox,
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate } from "react-router-dom";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import ContentTop from "../../../components/ContentTop";
import CustomButton from "../../../components/custom/CustomButton";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/MainLayout";
import tableData from "../../../config/data/loanProducts.json"
import TextArea from "antd/es/input/TextArea";

const { Content } = Layout;
const { Text, Title } = Typography;
const Search = Input;

const AddSYA2500 = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState("/sya2500");
    const [switchLabel, setSwitchLabel] = useState("Dark Mode");
    const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
    const [menuBG, setMenuBG] = useState("#2F172D");
    const [searchColorBgContainer, setSearchColorBgContainer] =
        useState("#3B2639");
    const [menuTheme, setMenuTheme] = useState("dark");
    const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
    const [logoDimensions, setLogoDimensions] = useState(100);
    const [menuSearchBarState, setMenuSearchBarState] = useState(false);
    const [menuSearchIconState, setMenuSearchIconState] = useState(true);
    const [switchLabelState, setSwitchLabelState] = useState(false);

    function onSwitchClick() {
        if (switchLabel === "Dark Mode") {
            setSwitchLabel("Light Mode");
            setMenuBG("#fff");
            setSearchColorBgContainer("#f7f8fa");
            setSwitchLabelColor("#8c8f9f");
            setMenuTheme("light");
        } else {
            setSwitchLabelColor("#aeaeae");
            setSwitchLabel("Dark Mode");
            setMenuBG("#2F172D");
            setSearchColorBgContainer("#3B2639");
            setMenuTheme("dark");
        }
    }

    function onMenuSelect(menuItems) {
        // console.log(menuItems.key);
        setSelectedKey(menuItems.key);
        navigate(menuItems.key, { replace: false });
    }

    useEffect(() => {
        if (collapsed === true) {
            setLeftLayoutMargin(71);
            setLogoDimensions(50);
            setMenuSearchBarState(true);
            setMenuSearchIconState(false);
            setSwitchLabelState(true);
        } else {
            setLeftLayoutMargin(190);
            setLogoDimensions(100);
            setMenuSearchBarState(false);
            setMenuSearchIconState(true);
            setSwitchLabelState(false);
        }
    });

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                components: {
                    Layout: {
                        siderBg: menuBG,
                    },
                    Menu: {
                        darkItemBg: menuBG,
                        darkSubMenuItemBg: "#241223",
                    },
                },
            }}
        >
            <MainLayout
                collapsed={collapsed}
                searchColorBgContainer={searchColorBgContainer}
                theme={menuTheme}
                defaultSelectedKeys={selectedKey}
                items={menuItems}
                onClick={onMenuSelect}
                switchLabel={switchLabel}
                onSwitchClick={onSwitchClick}
                switchLabelColor={switchLabelColor}
                logoDimensions={logoDimensions}
                menuSearchBarState={menuSearchBarState}
                menuSearchIconState={menuSearchIconState}
                switchLabelState={switchLabelState}
                setCollapsed={setCollapsed}
                leftLayoutMargin={leftLayoutMargin}
                colorBgContainer={colorBgContainer}
            >
                <MainPage titleOfPage={"Add KYC Category"} />
            </MainLayout>
        </ConfigProvider>
    );
};

const iconMap = {
    Authorised: <CheckOutlined />,
    Unauthorised: <CloseOutlined />,
    Disabled: <WarningOutlined />,
};

function MainPage(props) {
    const [fieldContent, setFieldContent] = useState(<AddSYA2500Form />);
    const navigate = useNavigate();

    function CustType(value) {
        console.log(value);
        if (value === "individual") {
            setFieldContent(<AddSYA2500Form />);
        } else if (value === "company") {
            setFieldContent(<AddSYA2500Form />);
        }
    }

    return (
        <div style={{ marginBottom: 50 }}>
            <ContentTop titleOfPage={"Add KYC Category"}>
                <BreadcrumbItem>
                    <a href="/dashboard">Home</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <a href="/sya2500">KYC Category</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Text>Add KYC Category</Text>
                </BreadcrumbItem>
            </ContentTop>
            <div>
                {fieldContent}
            </div>
            <Row gutter={16}></Row>
        </div>
    );
}

function AddSYA2500Form() {
    const navigate = useNavigate();

    function onCancel() {
        navigate("/sya2500", { replace: false });
    }

    const onSubmit = (values) => {
        console.log("Success:", values);
    };

    return (
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>

            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}
            >
                <Card
                    style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                >
                    <Row style={{ justifyContent: "space-between" }}>

                        <Col span={8}>
                            <Form.Item
                                name="name"
                                label={<Text strong>Name</Text>}
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}
                            >
                                <Input
                                    placeholder="xxxxxxxx"
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                name="maximumAccountBalance"
                                label={<Text strong>Maximum Account Balance </Text>}
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}>
                                <Input
                                    placeholder="xxxxxxxx"
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                name="description"
                                label={<Text strong>Description </Text>}
                            >
                                <TextArea
                                    placeholder="Enter a description"
                                    style={{ width: "45vh", height: "15vh" }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row style={{ justifyContent: "space-between" }}>

                        <Col span={8}>
                            <Form.Item
                                name="requiredKYCEvidence"
                                label={<Text strong>Required KYC Evidence</Text>}
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}
                            >
                                <Select
                                    placeholder="Select an option"
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item name="allowedLoanProducts"
                                label={<Text strong>Allowed Loan Products </Text>}
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}>
                                <Select
                                    placeholder="Select an option"
                                    style={{ width: "30vh" }}
                                    showSearch />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item name="allowedSavingsProducts"
                                label={<Text strong>Allowed Savings Products </Text>}
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}>
                                <Select placeholder="Select an option" style={{ width: "30vh" }}
                                showSearch
                                     />
                            </Form.Item>
                        </Col>
                    </Row>
                                <Row>
                                <Form.Item name="active"
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}>
                                <Checkbox><Text strong>Active </Text></Checkbox> 
                                    
                            </Form.Item>
                                </Row>
                </Card>
                <Form.Item>
                    <Row>
                        <CustomButton
                            content="Submit"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            htmlType="submit"
                            backgroundColor="#92428B"
                            colorText="white"
                            hoverBackground="#AD4EA7"
                        />
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "1%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={onCancel}
                        />
                    </Row>
                </Form.Item>
            </Card>
        </Form>
    );
}

export default AddSYA2500;
